/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ComponentsSlideComponent } from './ComponentsSlideComponent'
export type SectionsSlidesComponent = {
  id?: number
  __component?: string
  title?: string
  items?: Array<ComponentsSlideComponent>
  reverse?: boolean
  speed?: number
  noCutout?: boolean
  style?: SectionsSlidesComponent.style
}
export namespace SectionsSlidesComponent {
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
    WHITE = 'White',
  }
}
